import ApiClient from './ApiClient';

class ProjectRisks extends ApiClient {
  constructor() {
    super('risks', { accountScoped: true });
    this.projectId = null;
  }

  get url() {
    return `${this.baseUrl()}/projects/${this.projectId}/risks`;
  }

  get(projectId) {
    this.projectId = projectId;
    return super.get();
  }

  create(projectId, data) {
    this.projectId = projectId;
    return super.create({ risk: data });
  }

  update(projectId, id, data) {
    this.projectId = projectId;
    return super.update(id, { risk: data });
  }

  delete(projectId, id) {
    this.projectId = projectId;
    return super.delete(id);
  }
}

export default new ProjectRisks();
